import * as localeActionTypes from '../constants/index';

export const changeLocale = locale => ({
  type: localeActionTypes.CHANGE_LOCALE_LANGUAGE_SUCCESS,
  locale
});
